import React, { Component } from "react";

export default class Space extends Component {
  render() {
    const { space } = this.props;
    const { direction } = this.props.style;
    let children = this.props.children;
    children = children.filter((c) => !!c);
    let sortedChildren = children
      .slice()
      .sort((c1, c2) => c1.props.order - c2.props.order);
    let len = React.Children.count(children);

    const style = (i, len) => {
      if (i === 0) {
        return {
          marginRight: direction == "ltr" ? space || 10 : 0,
          marginLeft: direction == "rtl" ? space || 10 : 0,
        };
      }
      if (i === len - 1) {
        return {
          marginLeft: direction == "ltr" ? space || 10 : 0,
          marginRight: direction == "rtl" ? space || 10 : 0,
        };
      }
      return { marginRight: space || 10, marginLeft: space || 10 };
    };
    return (
      <div style={{ ...this.props.style }}>
        {React.Children.map(sortedChildren, (child, i) => (
          <span key={`${i}`} style={style(i, len)}>
            {child}
          </span>
        ))}
      </div>
    );
  }
}
